import { useMemo } from 'react';
import { calcularTotalesFactura } from '../utils/facturaCalculos';
import type { DetalleFacturaCompra } from '../types/facturas';

/**
 * Hook para calcular totales de factura (sin useEffect - derived state)
 */
export const useFacturaTotales = (
  detalles: DetalleFacturaCompra[],
  valoresIncluyenIva: boolean = false
) => {
  const totales = useMemo(() => {
    return calcularTotalesFactura(detalles, valoresIncluyenIva);
  }, [detalles, valoresIncluyenIva]);

  return totales;
};
